import './brokerIAProductBanner.scss';

import React from 'react';
import { PropTypes } from 'prop-types';

import BannerCard from '../shared/bannerCard/bannerCard';

import { i18n } from 'core/i18n';
const { formatText } = i18n;

const BrokerIAProductBanner = ({
    predictionDetail,
    titleKey = 'brokerIA-productBanner_title',
    estimatedOneMonthKey = 'brokerIA-productBanner_estimated_oneMonth',
    estimatedThreeMonthsKey = 'brokerIA-productBanner_estimated_threeMonths',
    estimatedSixMonthsKey = 'brokerIA-productBanner_estimated_sixMonths',
    estimatedTwelveMonthsKey = 'brokerIA-productBanner_estimated_twelveMonths',
    disclaimerKeyPart1 = 'brokerIA-productBanner_disclaimer',
    disclaimerKeyPart2 = 'brokerIA-productBanner_disclaimer_part2',
    disclaimerLinkUrlKey = 'brokerIA-productBanner_disclaimer_linkUrl',
    disclaimerLinkTextKey = 'brokerIA-productBanner_disclaimer_textUrl',
    currentPrice
}) => {
    return (
        <div className="brokerIA-productBanner">
            <div className="brokerIA-productBanner__container">
                <h3 className="brokerIA-productBanner__title">{formatText(titleKey)}</h3>

                <div className="brokerIA-productBanner__cards">
                    <BannerCard
                        realTimeValue={predictionDetail.get('realTimeValue')}
                        percentPrediction={predictionDetail.get('forecast').get('oneMonthPrediction')}
                        currency={predictionDetail.get('currency')}
                        estimateKey={estimatedOneMonthKey}
                        currentPrice={currentPrice}
                        />

                    <BannerCard
                        realTimeValue={predictionDetail.get('realTimeValue')}
                        percentPrediction={predictionDetail.get('forecast').get('threeMonthsPrediction')}
                        currency={predictionDetail.get('currency')}
                        estimateKey={estimatedThreeMonthsKey}
                        currentPrice={currentPrice}
                        />

                    <BannerCard
                        realTimeValue={predictionDetail.get('realTimeValue')}
                        percentPrediction={predictionDetail.get('forecast').get('sixMonthsPrediction')}
                        currency={predictionDetail.get('currency')}
                        estimateKey={estimatedSixMonthsKey}
                        currentPrice={currentPrice}
                        />

                    <BannerCard
                        realTimeValue={predictionDetail.get('realTimeValue')}
                        percentPrediction={predictionDetail.get('forecast').get('twelveMonthsPrediction')}
                        currency={predictionDetail.get('currency')}
                        estimateKey={estimatedTwelveMonthsKey}
                        currentPrice={currentPrice}
                    />
                </div>

                <div className="brokerIA-productBanner__disclaimer">
                    <p>
                        {formatText(disclaimerKeyPart1)}
                        <a className='brokerIA-productBanner__disclaimer_link' href={formatText(disclaimerLinkUrlKey)}>{formatText(disclaimerLinkTextKey)}</a>
                        {formatText(disclaimerKeyPart2)}
                    </p>
                </div>
            </div>
        </div>
    );
};

BrokerIAProductBanner.propTypes = {
    predictionDetail: PropTypes.object,
    titleKey: PropTypes.string.isRequired,
    estimatedOneMonthKey: PropTypes.string.isRequired,
    estimatedThreeMonthsKey: PropTypes.string.isRequired,
    estimatedSixMonthsKey: PropTypes.string.isRequired,
    estimatedTwelveMonthsKey: PropTypes.string.isRequired,
    disclaimerKey: PropTypes.string.isRequired,
    currentPrice: PropTypes.number.isRequired
};

export default BrokerIAProductBanner;
